//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "InFlightPaO2_info",
  data() {
    return {
    };
  },
  components: {
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  }
};



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Pulm/InFlightPaO2_info.vue